export default __webpack_public_path__ + "static/media/homevap_logo.5226a83b.png";